<template>
  <div>
    <div class="topnav">
      <a v-for="m in menu" :key="m.id" style="color: white;cursor: pointer;" :class="m.class" :href="m.path">{{ m.name }}</a>
      <a v-if="currentUser" class="" style="color: white;cursor: pointer;" @click="logOut()">ออกจากระบบ</a>
    </div>
    <router-view />
  </div>
</template>


<script>

export default {
  name: "app",
  components: {
  },
  data() {
    return {
      show: true,
      menu: []
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      setTimeout(function () {
        location.reload();
      }, 500);
      this.$router.push("/");
    },
  },
  mounted() {
    if (this.$route.params.name == "map" || this.$route.name == "login" || this.$route.name == "register") {
      this.show = false;
    }
    this.menu.push(
    //   {
    //   name:'EMA',
    //   path:'/ema',
    //   class:''
    // },
    {
      name:'overviews',
      path:'/',
      class:'active'
    },
    //   {
    //   name:'percent',
    //   path:'/percent',
    //   class:''
    // },
    // {
    //   name:'calculate',
    //   path:'/calculate',
    //   class:''
    // },
    )
    console.log(this.$route.path);
    for (let m = 0; m < this.menu.length; m++) {
          this.menu[m].class = ''
    if (this.menu[m].path == this.$route.path) {
            this.menu[m].class = 'active'
          }
          else if (this.$route.path == '/') {
            if (this.menu[m].path == '/') {
              this.menu[m].class = 'active'
            }
            
          }
        }
// console.log(this.currentUser.role_id);
    // if (this.currentUser) {
    //   UserService.getMenubyRoleID(this.currentUser.role_id).then((res) => {
    //     this.menu = res.data
    //     // console.log(this.menu);
    //     for (let m = 0; m < this.menu.length; m++) {
    //       this.menu[m].class = ''
    //       if (this.menu[m].url == this.$route.path) {
    //         this.menu[m].class = 'active'
    //       }
    //     }
    //   //   this.menu.push({
    //   //     name:'รายการสินค้าที่ตรวจสอบทั้งหมด',
    //   // url:'/scraping',
    //   // class:''
    //   //   })
    //   })
    // }



  },
};
</script>

<style>
/* Add a black background color to the top navigation */
.topnav {
  background-color: #333;
  overflow: hidden;
}

/* Style the links inside the navigation bar */
.topnav a {
  float: left;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
}

/* Change the color of links on hover */
.topnav a:hover {
  background-color: rgb(31, 82, 233);
  color: black;
}

/* Add a color to the active/current link */
.topnav a.active {
  background-color: rgb(31, 82, 233);
  color: white;
}
</style>